// extracted by mini-css-extract-plugin
module.exports = {"infoOptionCard":"chat_infoOptionCard__3Wh9t","readMarker":"chat_readMarker__22QMh"};